import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"flowchart"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3.00012 6.75008H8.06723V3.24992H3.00012V6.75008Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3 17.2497H8V20.7499H3V17.2497Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21.0001 5C21.0001 6.10457 20.1047 7 19.0001 7C17.8955 7 17.0001 6.10457 17.0001 5C17.0001 3.89543 17.8955 3 19.0001 3C20.1047 3 21.0001 3.89543 21.0001 5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21.0001 19.0001C21.0001 20.1046 20.1047 21.0001 19.0001 21.0001C17.8955 21.0001 17 20.1043 17 18.9998C17 17.8952 17.8955 17.0001 19.0001 17.0001C20.1047 17.0001 21.0001 17.8955 21.0001 19.0001Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3.00011 13.7501H8.00011V10.2499H3.00011V13.7501Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21.0001 12C21.0001 13.1046 20.1047 14 19.0001 14C17.8955 14 17.0001 13.1046 17.0001 12C17.0001 10.8954 17.8955 9.99999 19.0001 9.99999C20.1047 9.99999 21.0001 10.8954 21.0001 12Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.56723 10.2499V6.75008M5.56723 6.75008H3.00012V3.24992H8.06723V5M5.56723 6.75008H8.06723V5M8.06723 5H17.0001M17.0001 5C17.0001 6.10457 17.8955 7 19.0001 7C20.1047 7 21.0001 6.10457 21.0001 5C21.0001 3.89543 20.1047 3 19.0001 3C17.8955 3 17.0001 3.89543 17.0001 5ZM5.5 13.7497V17.2497M8 18.9998V17.2497H3V20.7499H8V18.9998ZM8 18.9998H17M17 18.9998C17 20.1043 17.8955 21.0001 19.0001 21.0001C20.1047 21.0001 21.0001 20.1046 21.0001 19.0001C21.0001 17.8955 20.1047 17.0001 19.0001 17.0001C17.8955 17.0001 17 17.8952 17 18.9998ZM8.00011 12V13.7501H3.00011V10.2499H8.00011V12ZM8.00011 12C8.00011 12 13.4854 12 17.0001 12M17.0001 12C17.0001 13.1046 17.8955 14 19.0001 14C20.1047 14 21.0001 13.1046 21.0001 12C21.0001 10.8954 20.1047 9.99999 19.0001 9.99999C17.8955 9.99999 17.0001 10.8954 17.0001 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Flowchart = Vue.extend<IconProps>({
  name: 'FlowchartIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'flowchart',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Flowchart;
